<template>
  <div class="internal-navbar">
    <ul class="nav justify-content-end">
      <li class="nav-item" v-for="item in items" :key="item">
        <a class="nav-link" :class="{ active: active === item}" @click="clickHandler(item)">{{item}}</a>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
interface Props {
  items?: string[];
  active?: string;
}

withDefaults(defineProps<Props>(), {
  items: () => [],
  active: ''
});

const emit = defineEmits<{
  navigate: [menuItem: string];
}>();

function clickHandler(menuItem: string) {
  emit('navigate', menuItem);
}
</script>

<style scoped lang="scss">
@use "@/variables.scss" as *;

.nav {
  text-align: right;
}

.nav li a {
  padding:5px 0;
  margin-left: 15px;
}

.nav-link {
  cursor: pointer;
}

.nav-link {
  color: $linkColour !important;
}


.nav-link.active {
  font-weight: bold;
  color: $bgColour !important;
}

.internal-navbar {
  
  margin: 20px auto 20px auto;
  border-bottom: 2px solid $linkColour;
  font-weight: bold;
  color: $bgColour;
}
</style>